var _path, _path2, _line, _path3, _circle, _path4, _circle2, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLifeInsurance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    width: 96,
    height: 96,
    role: "img",
    "aria-label": "Life insurance",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Life insurance") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 16C31 16 17 27 16 40h64C79 27 65 16 48 16z",
    fill: "#1f4e79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 40c1-3 4-5 7-5s6 2 7 5c1-3 4-5 7-5s5 2 7 5c1-3 4-5 7-5s6 2 7 5c1-3 4-5 7-5s6 2 7 5",
    fill: "#1a3a5c"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 16,
    x2: 48,
    y2: 60,
    stroke: "#1a3a5c",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60c0 5-3 8-8 8",
    fill: "none",
    stroke: "#1a3a5c",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 60,
    r: 6,
    fill: "#1f4e79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 86V72a9 9 0 0118 0v14z",
    fill: "#1f4e79"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 62,
    r: 5,
    fill: "#1f4e79"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53 86V74a7 7 0 0114 0v12z",
    fill: "#1f4e79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeInsurance);
export default __webpack_public_path__ + "static/media/life-insurance.a59de1bb72036f82bbdcec74ba246bce.svg";
export { ForwardRef as ReactComponent };